<template>
	<div class="category">
		<ManagingSection :isTable="true">
			<table class="table-main">
				<thead>
					<tr>
						<th class="category__num">항번</th>
						<th class="category__name">브랜드 카테고리명</th>
						<th class="category__order">정렬순서</th>
						<th class="cateogry__display">전시여부</th>
						<th class="category__image">이미지</th>
						<th class="category__brand-num">브랜드수</th>
						<th class="category__button">수정</th>
						<th class="category__button">삭제</th>
						<th class="category__button">이동</th>
					</tr>
				</thead>
				<tbody>
					<tr
						v-for="list in categoryList"
						:key="list.idBrandCategory"
					>
						<td class="category__num">
							{{ list.idBrandCategory }}
						</td>
						<td class="category__name">
							<input
								type="text"
								class="input-text"
								placeholder="브랜드 카테고리"
								v-model="list.brandCategoryText"
							/>
						</td>
						<td class="category__order">
							<input
								type="number"
								class="input-text"
								placeholder="정렬순서"
								v-model="list.sortKey"
								@input="checkSortKey(list.idBrandCategory)"
							/>
						</td>
						<td class="category__display">
							<RadioList
								class="radio-box__input"
								:radioList="radioList"
								v-model="list.isDisplay"
								keyName="id"
								valueName="value"
							/>
						</td>
						<td class="category__image">
							<div class="category__view">
								<ImageExif
									:src="`${imageHost}${list.fileDir}/${list.fileSaveName}`"
									v-if="list.fileDir"
								/>
							</div>
							<input
								type="file"
								placeholder="브랜드 카테고리 이미지"
								ref="brandCategoryImage"
								@change="
									handleFileChange(
										$event,
										list.idBrandCategory
									)
								"
							/>
						</td>
						<td class="category__brand-num">
							{{ list.brandCount }}
						</td>
						<td class="category__button">
							<button
								class="btn orange"
								@click="updateCategory(list.idBrandCategory)"
							>
								수정
							</button>
						</td>
						<td class="category__button">
							<button
								class="btn red"
								@click="deleteCategory(list.idBrandCategory)"
							>
								삭제
							</button>
						</td>
						<td class="category__button">
							<button
								class="btn mint"
								@click="moveCategory(list.idBrandCategory)"
							>
								이동
							</button>
						</td>
					</tr>
				</tbody>
			</table>
		</ManagingSection>
	</div>
</template>
<script>
	import ImageExif from '../ImageExif.vue';
	import RadioList from '../RadioList.vue';
	import { imageUpload } from '@/util';
	import ManagingSection from '@/components/layout/ManagingSection.vue';

	export default {
		components: {
			RadioList,
			ImageExif,
			ManagingSection,
		},
		data() {
			return {
				radioList: [
					{ id: true, value: '예' },
					{ id: false, value: '아니오' },
				],
				categoryList: [],
				fileDir: '',
				fileSaveName: '',
				brandCateImg: [],
			};
		},
		computed: {
			imageHost: {
				get() {
					return this.$store.state.env.IMAGE_STORAGE_PATH;
				},
			},
		},
		async created() {
			await this.getList();
		},
		methods: {
			async uploadImage(imageObj, idBrandCategory) {
				const { extension, fileObject } = imageObj;

				try {
					const res = await imageUpload(
						extension,
						'brand-cate-img',
						fileObject
					);
					const filePath = `/${res.config.data.get('key')}`;
					const fileSaveName = filePath.split('/').pop();
					const imgPath = filePath.replace(/\/[^/]+\/?$/, '');

					const categoryIndex = this.categoryList.findIndex(
						category => category.idBrandCategory === idBrandCategory
					);
					if (categoryIndex !== -1) {
						this.$set(
							this.categoryList[categoryIndex],
							'fileDir',
							imgPath
						);
						this.$set(
							this.categoryList[categoryIndex],
							'fileSaveName',
							fileSaveName
						);
					}
				} catch (err) {
					console.error(err);
				}
			},

			async handleFileChange(event, idBrandCategory) {
				const files = [...event.target.files];
				const readFileList = await Promise.all(
					files.map(file => this.readFile(file))
				);
				const urlList = readFileList.map(({ target }) => target.result);
				this.addImg(urlList, files, idBrandCategory);
			},

			addImg(urlList, files, idBrandCategory) {
				const list = urlList.map((url, idx) => {
					const srcObj = {
						src: url,
						fileObject: files[idx],
						extension: files[idx].type.split('/').pop(),
					};
					return srcObj;
				});
				this.uploadImage(list[0], idBrandCategory);
			},

			readFile(file) {
				return new Promise(resolve => {
					const reader = new FileReader();
					reader.onload = e => {
						const img = new Image();
						img.src = e.target.result;
						img.onload = () => {
							resolve(e);
						};
					};
					reader.readAsDataURL(file);
				});
			},

			async getList() {
				try {
					const { data } = await this.$axiosAdmin2.get(
						'/api/brands/category'
					);
					this.categoryList = data;
				} catch (e) {
					console.error(e);
				}
			},
			async updateCategory(id) {
				try {
					const params = {
						idBrandCategory: id,
						brandCategoryText: this.categoryList.find(
							category => category.idBrandCategory === id
						).brandCategoryText,
						sortKey: this.categoryList.find(
							category => category.idBrandCategory === id
						).sortKey,
						isDisplay: this.categoryList.find(
							category => category.idBrandCategory === id
						).isDisplay,
						fileDir: this.categoryList.find(
							category => category.idBrandCategory === id
						).fileDir,
						fileSaveName: this.categoryList.find(
							category => category.idBrandCategory === id
						).fileSaveName,
					};
					await this.$axiosAdmin2.post(
						'/api/brands/category',
						params
					);
					alert('수정되었습니다.');
					await this.getList();
				} catch (e) {
					console.error(e);
				}
			},
			async deleteCategory(id) {
				try {
					if (
						this.categoryList.find(
							category => category.idBrandCategory === id
						).brandCount > 0
					) {
						alert(
							'브랜드 카테고리에 속한 브랜드가 존재합니다. 브랜드 카테고리를 삭제하려면 브랜드 카테고리에 속한 브랜드를 먼저 삭제해주세요.'
						);
						return;
					}
					if (!confirm('삭제하시겠습니까?')) return;
					await this.$axiosAdmin2.delete(
						`/api/brands/category/${id}`
					);
					await this.getList();
				} catch (e) {
					alert(
						'삭제에 실패하였습니다. 지속적인 문제 발생시 개발팀에 문의주세요.'
					);
					console.error(e);
				}
			},
			async moveCategory(id) {
				this.$store.commit(
					'setSelectedBrandCategory',
					this.categoryList.find(
						category => category.idBrandCategory === id
					)
				);
				this.$router.push(`/brand/mapping/${id}`);
			},

			checkSortKey(id) {
				const sortKey = this.categoryList.find(
					category => category.idBrandCategory === id
				).sortKey;
				if (sortKey < 0) {
					alert('1보다 작은 숫자는 입력할 수 없습니다.');
					this.categoryList.find(
						category => category.idBrandCategory === id
					).sortKey = 0;
				}
			},
		},
	};
</script>
<style lang="scss" scoped>
	.category {
		margin-top: 100px;
		.category__num {
			width: 4%;
		}
		.category__name {
			width: 20%;
		}
		.category__order {
			width: 10%;
		}
		.category__display {
			width: 12%;
		}
		.category__image {
			width: 20%;
		}
		.category__view {
			display: flex;
			justify-content: center;
			align-items: center;
			flex-direction: column;
			margin-bottom: 30px;
		}
		.category__brand-num {
			width: 8%;
		}
		.category__button {
			width: 5%;
		}
	}
</style>
